<template>
    <btn v-if="followModelData && (!$auth.user || $auth.user.id !== followModelData.id || followModelData.model_name !== 'user')"
         :outlined="isFollowing"
         :value="isFollowing"
         :small="small"
         :color="color ?? 'success'"
         :aria-label="isFollowing ? $t('action.unfollow') : $t('action.follow')"
         :loading="apiRequestLoading"
         @click.prevent="handleClick">
        <icon v-if="isFollowing" :icon="icons.following"/>
        <icon v-else-if="!small" :icon="icons.follow"/>
        <span>{{ isFollowing ? $t('label.following') : $t('action.follow') }}</span>
    </btn>
</template>

<script>

import FollowButtonMixin from "../../mixins/FollowButtonMixin";

export default {
    name: "FollowTextButton",

    mixins: [FollowButtonMixin],

    props: {
        color: {
            type: String,
            default: null
        },
        small: {
            type: Boolean,
            default: null
        }
    }

}
</script>